<template>
    <div class="reviews">
        <card class="mb-0" body-classes="p-0">
            <el-table class="table-responsive table-flush"
                    header-row-class-name="thead-light"
                    :data="reviews">

                <el-table-column width="200">
                    <div slot="header">
                        {{ $t('assessments.assessment') }}
                    </div>
                    <template v-slot="{row}">
                        <h4 class="mb-0">
                            {{ row.name }}
                        </h4>
                    </template>
                </el-table-column>

                <el-table-column>
                    <div slot="header">
                        {{ id == -1 
                            ? $t('dashboard.comment')
                            : $t('competencies.rating') + '/' + $t('dashboard.comment')
                        }}
                    </div>
                    <template v-slot="{row}">

                        <rating
                            :value="row.rating"
                            :options="ratingOptions"
                            :disabled="true"
                            v-if="row.rating !== null && row.rating !== undefined && row.rating != -1"
                        >
                        </rating>
                        
                        <!-- Keep it on the same line -->
                        <p class="description mb-0"
                            :class="{'with-rating': row.rating !== null && row.rating !== undefined && row.rating != -1}"
                        >{{row.comment}}</p>

                    </template>
                </el-table-column>
                
                <el-table-column width="30" class-name="help">
                    <div slot="header">
                        <el-popover placement="left">
                            <i slot="reference" class="far fa-question-circle float-right"></i>
                            <div class="pt-2 pr-2 pl-2 help">
                                <h3>{{ title }}</h3>
                                <p v-html="help"></p>
                            </div>
                        </el-popover>
                    </div>
                </el-table-column>

            </el-table>
        </card>
    </div>
</template>

<script>
    import Rating from '../Rating'

    export default {

        components: {
            Rating
        },

        props: {

            ratingOptions: {
                type: Array,
                default: null
            },

            id: {
                type: Number,
                required: true
            },

            title: {
                type: String,
                required: true
            },

            help: {
                type: String,
                required: true
            },

            lang: {
                type: String,
                required: true
            },

            registration: {
                type: Object,
                required: true
            },

            simulations: {
                type: Array,
                required: true
            },
        },

        computed: {
            reviews() {
                return this.simulations.filter(sim => sim.assessment && !sim.private)
                    .map(sim => {
                        let item = {
                            name: sim.name,
                            comment: null,
                            rating: null,
                        }

                        // No state.
                        if (!sim.state || sim.state.empty || !sim.state.published) {
                            return item
                        }
                        
                        // Not visible yet.
                        if (!this.canShowReview(sim)) {
                            return item
                        }
                        
                        // Visible.
                        if (this.id == -1) {
                            return {
                                name: sim.name,
                                comment: sim.state.comment,
                                rating: null,
                            }
                        }
                        return  {
                            name: sim.name,
                            comment: sim.state.domain_comments[this.id],
                            rating: sim.state.domains[this.id],
                        }
                    })
            },
        },

        methods: {
            canShowReview(simulation) {
                if (this.$permissions.hasRight('dashboard.overviews.always')) {
                    return true
                }
                if (simulation.private) {
                    return false
                }
                if (this.$permissions.hasRight('dashboard.overviews.closed')) {
                    return this.simulationClosed(simulation)
                }
                if (this.$permissions.hasRight('dashboard.overviews.date-or-closed')) {
                    if (simulation.assessment) {
                        return this.simulationAfterDate(simulation)
                    } else {
                        return this.simulationClosed(simulation)
                    }
                }
                return false
            },

            simulationClosed(simulation) {
                return simulation.state.date
                    && new Date(simulation.state.date) <= new Date()
            },

            simulationAfterDate(simulation) {
                return simulation.state.meta
                    && simulation.state.meta.learner_access_date
                    && new Date(simulation.state.meta.learner_access_date) <= new Date()
            },
        }
    }
</script>

<style scoped>

    .fa-question-circle {
        cursor: pointer;
        font-size: 1rem;
    }
    .help {
        max-width: 600px;
        word-break: break-word;
    }
    .description {
        white-space: pre-wrap;
        padding-left: 0;
    }
    .description.with-rating {
        padding-left: 3rem;
    }
    .reviews >>> .rating {
        float: left;
    }
    .reviews >>> .rating button {
        width: 30px;
        height: 30px;
    }
    .reviews >>> th.help {
        padding-left: 0;
        padding-right: 0;
    }
    .reviews >>> .card {
        box-shadow: 0 0 2rem 0 rgba(136,152,170,.3);
        margin-top: 2rem;
    }
    .reviews >>> .el-table::before {
        height: 0 !important;
    }

</style>
